import { AccountSettingsFieldsNamesEnum } from 'types/settings.types';
import * as jsvat from '@accountable/jsvat';
import { checkVAT } from '@accountable/jsvat';
import Joi from 'joi';
import { settingsErrorMessagesFormatter } from 'utils/settings/settingsHelpers';

const validationSchema = Joi.object({
  [AccountSettingsFieldsNamesEnum.VATNumber]: Joi.string()
    .required()
    .custom((value, helpers) => {
      const { isValid } = checkVAT(value, [jsvat.belgium, jsvat.germany]);

      if (!isValid) {
        return helpers.error('any.invalid');
      }
      return value;
    })
    .messages(
      settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.VATNumber),
    ),
});

export { validationSchema };
